/* Bazan Premium Line PDP — behaviour for bz-prm-* sections.
   Safe to load multiple times (guarded). Re-inits on theme editor section load. */
(function () {
  'use strict';
  if (window.__bzPrm) return;
  window.__bzPrm = true;
  document.documentElement.classList.add('prm-js');

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents, format) {
    format = format || '${{amount}}';
    var v = (cents || 0) / 100;
    var withDec = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDec = Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return noDec;
      if (k === 'amount_with_comma_separator') return v.toFixed(2).replace('.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return noDec.replace(/,/g, '.');
      return withDec;
    });
  }
  function pct(full, now) {
    if (!full || !now || now >= full) return 0;
    return Math.round((1 - now / full) * 100);
  }
  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  /* ---------------- Buy box ---------------- */
  function Main(root) {
    this.root = root;
    this.variants = JSON.parse($(root, '[data-prm-variants]').textContent);
    this.cfg = JSON.parse($(root, '[data-prm-cfg]').textContent);
    this.gi = parseInt(root.getAttribute('data-grind-index'), 10);
    this.si = parseInt(root.getAttribute('data-size-index'), 10);
    this.fmt = root.getAttribute('data-money-format');
    this.hideNa = root.getAttribute('data-hide-na') === 'true';
    this.form = $(root, '.prm-form');
    this.idInput = $(root, '[data-prm-id]');
    this.planInput = $(root, '[data-prm-plan-input]');
    this.planSel = $(root, '[data-prm-plan]');
    this.toggle = $(root, '[data-prm-refill-toggle]');
    this.refill = $(root, '[data-prm-refill]');
    this.cta = $(root, '[data-prm-cta]');
    this.sticky = $(root, '[data-prm-sticky]');

    var self = this;
    var init = this.find(function (v) { return String(v.id) === self.idInput.value; }) || this.variants[0];
    this.opts = init.options.slice();

    var hasUrlVariant = /[?&]variant=/.test(window.location.search);
    var ds = root.getAttribute('data-default-size');
    if (!hasUrlVariant && ds && this.si >= 0) {
      var t = this.opts.slice(); t[this.si] = ds;
      if (this.match(t)) this.opts = t;
    }
    this.sub = !!(this.toggle && this.toggle.checked);

    $$(root, '[data-prm-grind]').forEach(function (b) {
      b.addEventListener('click', function () { self.pickGrind(b.getAttribute('data-prm-grind')); });
    });
    $$(root, '[data-prm-size]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.closest('[data-prm-size-wrap]').classList.contains('is-na')) return;
        self.pickSize(b.getAttribute('data-prm-size'));
      });
    });
    [$$(root, '.prm-grind'), $$(root, '.prm-sizes')].forEach(function (groups) {
      groups.forEach(function (g) { g.addEventListener('keydown', function (e) { self.arrowNav(e, g); }); });
    });
    if (this.toggle) this.toggle.addEventListener('change', function () { self.sub = self.toggle.checked; self.render(); });
    if (this.planSel) this.planSel.addEventListener('change', function () { self.render(); });

    // Only our own selling_plan / id reach the cart: apps that auto-inject a
    // purchase widget into the form (e.g. Seal) add their own hidden inputs.
    this.form.addEventListener('formdata', function (e) {
      var v = self.current(), a = self.allocFor(v);
      e.formData.delete('selling_plan');
      if (self.sub && a) e.formData.set('selling_plan', self.planId());
      if (v) e.formData.set('id', v.id);
    });
    this.form.addEventListener('submit', function () {
      $$(self.form, '[name="selling_plan"]').forEach(function (el) { if (el !== self.planInput) el.disabled = true; });
    }, true);

    this.bindGallery();
    this.bindSticky();
    this.render(true);
  }
  Main.prototype.find = function (fn) {
    for (var i = 0; i < this.variants.length; i++) if (fn(this.variants[i])) return this.variants[i];
    return null;
  };
  Main.prototype.match = function (opts) {
    return this.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
  };
  Main.prototype.current = function () { return this.match(this.opts); };
  Main.prototype.planId = function () { return this.planSel ? parseInt(this.planSel.value, 10) : null; };
  Main.prototype.allocFor = function (v) {
    if (!v || !this.planSel) return null;
    var id = this.planId(), list = v.selling_plan_allocations || [];
    for (var i = 0; i < list.length; i++) if (list[i].selling_plan_id === id) return list[i];
    return null;
  };
  Main.prototype.pickGrind = function (val) {
    var t = this.opts.slice(); t[this.gi] = val;
    if (!this.match(t)) {
      var gi = this.gi;
      var alt = this.find(function (v) { return v.options[gi] === val && v.available; }) ||
                this.find(function (v) { return v.options[gi] === val; });
      if (!alt) return;
      t = alt.options.slice();
    }
    this.opts = t; this.render();
  };
  Main.prototype.pickSize = function (val) {
    var t = this.opts.slice(); t[this.si] = val;
    if (!this.match(t)) return;
    this.opts = t; this.render();
  };
  Main.prototype.arrowNav = function (e, group) {
    var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
    if (!keys[e.key]) return;
    var items = $$(group, '[role="radio"]').filter(function (b) {
      var w = b.closest('[data-prm-size-wrap]');
      return !(w && (w.hidden || w.classList.contains('is-na')));
    });
    var i = items.indexOf(document.activeElement);
    if (i < 0) return;
    e.preventDefault();
    var next = items[(i + keys[e.key] + items.length) % items.length];
    next.focus(); next.click();
  };
  Main.prototype.render = function (first) {
    var self = this, v = this.current() || this.variants[0], fmt = this.fmt;
    var alloc = this.allocFor(v);
    var subOn = this.sub && !!alloc;

    this.idInput.value = v.id;
    if (this.planInput) {
      this.planInput.disabled = !subOn;
      if (subOn) this.planInput.value = this.planId();
    }
    if (this.refill) this.refill.classList.toggle('is-on', this.sub);

    // grind buttons
    $$(this.root, '[data-prm-grind]').forEach(function (b) {
      var on = b.getAttribute('data-prm-grind') === self.opts[self.gi];
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
    });

    // size cards
    $$(this.root, '[data-prm-size]').forEach(function (b) {
      var val = b.getAttribute('data-prm-size');
      var wrap = b.closest('[data-prm-size-wrap]');
      var t = self.opts.slice(); t[self.si] = val;
      var vv = self.match(t);
      var on = val === self.opts[self.si];
      wrap.classList.toggle('is-na', !vv);
      wrap.hidden = !vv && self.hideNa;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.setAttribute('aria-disabled', vv ? 'false' : 'true');
      b.tabIndex = on ? 0 : -1;
      var p = $(b, '[data-prm-card-price]'), w = $(b, '[data-prm-card-was]'), s = $(b, '[data-prm-card-save]');
      if (!vv) { p.textContent = ''; w.textContent = ''; s.textContent = ''; return; }
      var a = self.sub ? self.allocFor(vv) : null;
      var now = a ? a.price : vv.price;
      var was = a ? vv.price : (vv.compare_at_price > vv.price ? vv.compare_at_price : 0);
      var off = pct(was, now);
      p.textContent = money(now, fmt);
      w.textContent = was && off ? money(was, fmt) : '';
      s.textContent = off ? self.cfg.saveText.replace('[pct]', off) : '';
    });

    // header price
    var now = subOn ? alloc.price : v.price;
    var was = subOn ? v.price : (v.compare_at_price > v.price ? v.compare_at_price : 0);
    var off = pct(was, now);
    $(this.root, '[data-prm-now]').textContent = money(now, fmt);
    var wasEl = $(this.root, '[data-prm-was]'), saveEl = $(this.root, '[data-prm-save]');
    wasEl.hidden = !off; wasEl.textContent = off ? money(was, fmt) : '';
    saveEl.hidden = !off; saveEl.textContent = off ? this.cfg.saveText.replace('[pct]', off) : '';
    $(this.root, '[data-prm-hint]').textContent = subOn
      ? this.cfg.hintSub.replace('[price]', money(v.price, fmt))
      : (this.planSel ? this.cfg.hintOnce : '');

    // refill pill + recurring line (always from the plan, even when off)
    var rs = $(this.root, '[data-prm-refill-save]');
    if (rs) {
      var ro = alloc ? pct(v.price, alloc.price) : 0;
      rs.hidden = !ro; rs.textContent = ro ? this.cfg.saveText.replace('[pct]', ro) : '';
    }
    var then = $(this.root, '[data-prm-then]');
    if (then) {
      // recurring price = last price adjustment (e.g. 25% first order, 20% after)
      var adj = alloc && alloc.price_adjustments ? alloc.price_adjustments : [];
      var rec = adj.length > 1 ? adj[adj.length - 1].price : (alloc ? (alloc.per_delivery_price || alloc.price) : 0);
      then.textContent = alloc ? this.cfg.thenText.replace('[price]', money(rec, fmt)) : '';
    }

    // CTA
    var label = !v.available ? this.cfg.soldOut : (subOn ? this.cfg.ctaSub : this.cfg.ctaOnce);
    this.cta.disabled = !v.available;
    $(this.cta, '[data-prm-cta-label]').textContent = label;

    // sticky
    if (this.sticky) {
      var gb = this.gi >= 0 ? $(this.root, '[data-prm-grind][aria-checked="true"]') : null;
      $(this.sticky, '[data-prm-sticky-grind]').textContent = gb ? ' · ' + gb.getAttribute('data-prm-grind-title') : '';
      $(this.sticky, '[data-prm-sticky-price]').textContent = money(now, fmt);
      $(this.sticky, '[data-prm-sticky-label]').textContent = label;
      $(this.sticky, '[data-prm-sticky-btn]').disabled = !v.available;
    }

    // media for variant
    if (!first && v.featured_media && v.featured_media.id) {
      var thumb = this.root.querySelector('[data-prm-thumb][data-media-id="' + v.featured_media.id + '"]');
      if (thumb) thumb.click();
    }

    // URL (keeps ?view= for template previews)
    if (!first && window.history && window.history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }
    this.root.dispatchEvent(new CustomEvent('prm:variant', { bubbles: true, detail: { variant: v, subscription: subOn } }));
  };
  Main.prototype.bindGallery = function () {
    var stage = $(this.root, '[data-prm-stage]');
    var thumbs = $$(this.root, '[data-prm-thumb]');
    if (!stage || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        stage.src = t.getAttribute('data-src');
        stage.srcset = t.getAttribute('data-srcset');
        stage.alt = t.getAttribute('data-alt');
        thumbs.forEach(function (o) { o.classList.remove('is-active'); o.removeAttribute('aria-current'); });
        t.classList.add('is-active'); t.setAttribute('aria-current', 'true');
      });
    });
  };
  Main.prototype.bindSticky = function () {
    var sticky = this.sticky, cta = this.cta, form = this.form;
    if (!sticky || !cta || !('IntersectionObserver' in window)) return;
    var btn = $(sticky, '[data-prm-sticky-btn]');
    btn.addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(cta); else cta.click();
    });
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
    }).observe(cta);
  };

  /* ---------------- Infinite note rail ---------------- */
  function loopRail(el) {
    if (el.getAttribute('data-looped')) return;
    var cards = Array.prototype.slice.call(el.children);
    if (cards.length < 3 || el.scrollWidth <= el.clientWidth + 8) return;
    el.setAttribute('data-looped', '1');
    cards.forEach(function (c) {
      var clone = c.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-shopify-editor-block');
      el.appendChild(clone);
    });
    requestAnimationFrame(function () {
      var seg = el.scrollWidth / 2;
      var first = el.children[cards.length];
      el.style.scrollSnapType = 'none';
      el.scrollLeft = first.offsetLeft - (el.clientWidth - first.offsetWidth) / 2;
      el.style.scrollSnapType = '';
      var wrapping = false;
      el.addEventListener('scroll', function () {
        if (wrapping) return;
        var max = el.scrollWidth - el.clientWidth;
        if (el.scrollLeft >= max - 2 || el.scrollLeft <= 2) {
          wrapping = true;
          el.style.scrollSnapType = 'none';
          el.scrollLeft += el.scrollLeft <= 2 ? seg : -seg;
          el.style.scrollSnapType = '';
          requestAnimationFrame(function () { wrapping = false; });
        }
      }, { passive: true });
    });
  }

  /* ---------------- Tabs ---------------- */
  function initTabs(scope) {
    var tabs = $$(scope, '[data-prm-tab]'), panels = $$(scope, '[data-prm-panel]');
    if (!tabs.length) return;
    function select(i, focus) {
      tabs.forEach(function (t, j) {
        var on = i === j;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (panels[j]) panels[j].hidden = !on;
      });
      if (focus) tabs[i].focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        select((i + d + tabs.length) % tabs.length, true);
      });
    });
  }

  /* ---------------- Story toggle ---------------- */
  function initStory(root) {
    var btn = $(root, '[data-prm-story-toggle]');
    if (!btn) return;
    var label = $(btn, '[data-prm-story-label]');
    btn.addEventListener('click', function () {
      var open = !root.classList.contains('is-open');
      root.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      label.textContent = btn.getAttribute(open ? 'data-open-label' : 'data-closed-label');
      observeReveals(root);
      if (!open) root.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
  }

  /* ---------------- Reveal ---------------- */
  var io = null;
  function observeReveals(scope) {
    var els = $$(scope, '[data-prm-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduceMotion) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    }
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------------- Scroll to buy ---------------- */
  function initGoto(scope) {
    $$(scope, '[data-prm-goto]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = (a.getAttribute('href') || '').slice(1);
        var target = id && document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        var first = document.querySelector('.prm-main [role="radio"][aria-checked="true"], .prm-main [data-prm-cta]');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, reduceMotion ? 0 : 500);
      });
    });
  }

  function init(scope) {
    $$(scope, '[data-prm-main]').forEach(function (el) { if (!el.__prm) el.__prm = new Main(el); });
    $$(scope, '[data-prm-rail]').forEach(loopRail);
    $$(scope, '[data-prm-tabs-scope]').forEach(initTabs);
    $$(scope, '[data-prm-story]').forEach(initStory);
    initGoto(scope);
    observeReveals(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
